import { cameraStore } from "../cameraStore"

export const useCameraStore = () => {
  const layout = cameraStore((state) => state.layout)
  const pageSize = cameraStore((state) => state.pageSize)
  const page = cameraStore((state) => state.page)
  const selectedCamera = cameraStore((state) => state.selectedCamera)
  const favorites = cameraStore((state) => state.favorites)
  const sortBy = cameraStore((state) => state.sortBy)

  const setLayout = cameraStore((state) => state.setLayout)
  const setPageSize = cameraStore((state) => state.setPageSize)
  const setPage = cameraStore((state) => state.setPage)
  const setSelectedCamera = cameraStore((state) => state.setSelectedCamera)
  const clearSelectedCamera = cameraStore((state) => state.clearSelectedCamera)
  const toggleFavorite = cameraStore((state) => state.toggleFavorite)
  const setSortBy = cameraStore((state) => state.setSortBy)

  return {
    layout,
    pageSize,
    page,
    selectedCamera,
    favorites,
    sortBy,
    setLayout,
    setPageSize,
    setPage,
    setSelectedCamera,
    clearSelectedCamera,
    toggleFavorite,
    setSortBy,
  }
}

export default useCameraStore
